import React from "react";
import AnnLogo from "./assets/logo/AnnLogo.svg";

const App = () => {
  return (
    <div>
      <h1>Soon...</h1>
      <img src={AnnLogo} />
    </div>
  );
};

export default App;
